import React from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import Modal from "./Modal";
import spinner from "../images/spinner.gif";
import "./Inbox.css";
import { checkUser, handleSignOut } from "../utils/database";
import TimeAgo from "javascript-time-ago";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightFromBracket,
  faUser,
} from "@fortawesome/free-solid-svg-icons";

function Dashboard() {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [logged, setLogged] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userdata, setUserdata] = useState({});
  const [message, setMessage] = useState([]);
  const [modalData, setModalData] = useState({});

  const accessToken = Cookies.get("accessToken");
  const accessTokenSecret = Cookies.get("accessTokenSecret");
  const accessProvider = Cookies.get("accessProvider");
  if (accessProvider == undefined) {
    Cookies.remove("accessToken", { path: "" });
    Cookies.remove("accessTokenSecret", { path: "" });
  }
  useEffect(() => {
    checkUser(accessProvider, accessToken, accessTokenSecret)
      .then((result) => {
        if (result) {
          document.title = "@" + result.username + " inbox";
          setLogged(true);
          setUserdata(result);
          const x = result.messages.map((message) => {
            const date = new Date(message.date);
            const timeAgo = new TimeAgo();
            const dateString = timeAgo.format(date);
            let truncateMessage;
            if (message.message.length > 40) {
              truncateMessage = message.message.substring(0, 40) + "...";
            } else {
              truncateMessage = message.message;
            }
            return {
              message: truncateMessage,
              date: dateString,
              sender: message.displaysender ? message.sender : "unknown",
            };
          });
          setMessage(x);
        }
      })
      .finally(() => setLoading(false));
  }, []);
  function handleLogOut() {
    handleSignOut().then(() => navigate("/login"));
  }

  return (
    <>
      <div className="container">
        {loading ? (
          <div className="spinner">
            <img src={spinner} />
          </div>
        ) : logged ? (
          <>
            <div className="container-user">
              <nav>
                <button
                  onClick={() => handleLogOut()}
                  className="button logout"
                >
                  <FontAwesomeIcon icon={faArrowRightFromBracket} size="lg" />
                  Log Out
                </button>
                <div>INBOX</div>
                <button
                  className="button inbox"
                  onClick={() => navigate("/dashboard")}
                >
                  <FontAwesomeIcon icon={faUser} size="lg" />
                  User
                </button>
              </nav>
              <div className="container-inbox">
                {message.toReversed().map((message, index) => (
                  <button
                    key={index}
                    className="inbox-card"
                    onClick={() => {
                      setOpenModal(true);
                      setModalData({
                        message: userdata.messages.toReversed()[index].message,
                        sender: message.sender,
                        date: message.date,
                      });
                    }}
                  >
                    <div className="inbox-sender">From {message.sender}</div>
                    <div className="inbox-message">{message.message}</div>
                    <div className="inbox-date">{message.date}</div>
                  </button>
                ))}
              </div>
            </div>
            {openModal && (
              <Modal message={modalData} handleModal={setOpenModal} />
            )}
          </>
        ) : (
          <>Login Failed</>
        )}
      </div>
    </>
  );
}

export default Dashboard;
